// extracted by mini-css-extract-plugin
export var equalColumn = "_fb-0";